let Domain = Object.freeze({
  live: "https://admin.edpass.co/service/api/master/",
  dev: "http://localhost:3001/api/master/",
  staging: "http://192.168.8.101:3002/api/v1/admin/",
  portal: "https://portal.edpass.co"
});

const trimTrailingSlash = value => String(value || "").replace(/\/+$/, "");
const normalizeApiDomain = value => {
  const baseUrl = trimTrailingSlash(value || Domain.live);
  if (/\/api\/master$/.test(baseUrl)) {
    return `${baseUrl}/`;
  }
  return `${baseUrl}/api/master/`;
};

export const apiDomain = normalizeApiDomain(process.env.VUE_APP_API || Domain.live);
export const portalDomain = process.env.VUE_APP_PORTAL || Domain.portal;
export const secondaryApiDomain = normalizeApiDomain(
  process.env.VUE_APP_API || Domain.live
);

export default {
  APP_DOMAIN: apiDomain,
  APP_DOMAIN_2: secondaryApiDomain,
  PORTAL_DOMAIN: portalDomain,
  get APP_HEADER() {
    const AuthStr = "Bearer ".concat(localStorage.token);
    return {
      headers: {
        Authorization: AuthStr
      }
    };
  },
  get APP_HEADER_FORM_DATA() {
    const AuthStr = "Bearer ".concat(localStorage.token);
    return {
      headers: {
        Authorization: AuthStr,
        "Content-Type": "multipart/form-data"
      }
    };
  },
  APP_DOMAIN_TOKEN: apiDomain,
  get APP_HEADER_TOKEN() {
    const AuthStr = "Bearer ".concat(localStorage.comToken);
    return {
      headers: {
        Authorization: AuthStr
      }
    };
  }
};
